import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRoutes } from './App';
import { AppProviders } from './Providers';
import { PwaStatus } from './ui/PwaStatus';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <AppRoutes />
      <PwaStatus />
    </AppProviders>
  </StrictMode>,
);
